<template>
  <div class="kd-thumbnails" v-if="SIDES">
    <ul class="kd-thumbnails__list">
      <kd-thumbnail
        v-for="side in SIDES"
        :key="side.id"
        :id="side.id"
        :is-active="side.id === ACTIVE_SIDE_ID"
        :thumbnail-url="thumbnailUrl(side.id)"
        :name="side.name"
      ></kd-thumbnail>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import KdThumbnail from '@/components/KdThumbnail.vue';
import {
  SIDES,
  FORMAT_ID,
  ACTIVE_SIDE_ID,
} from '@/store/getter-types';

export default {
  data() {
    return {
      // sides: [
      //   { label: 'Vorne', id: 'vorne' },
      //   { label: 'Innen Links', id: 'innen-links' },
      //   { label: 'Innen Rechts', id: 'innen-rechts' },
      //   { label: 'Hinten', id: 'hinten' },
      // ],
      baseUrl: process.env.BASE_URL,
    };
  },
  computed: {
    ...mapGetters([
      FORMAT_ID,
      SIDES,
      ACTIVE_SIDE_ID,
    ]),
    thumbnailUrl() {
      /* eslint-disable func-names */
      return function (sideId) {
        return `${this.baseUrl}assets/images/side-thumbnails/${this.FORMAT_ID}/${sideId}.svg`;
      };
    },
  },
  components: {
    KdThumbnail,
  },
};
</script>

<style lang="scss">
  .kd-thumbnails {
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .kd-thumbnails__list {
    display: flex;
    list-style: none;
    padding-bottom: 12px;
  }
</style>
